angular.module('crud')

.directive('crudButtons', function () {
  return {
    restrict:'E',
    replace:true,
    template:
    '<div layout="row" layout-align="end" layout-wrap flex>' +
        '<md-button class="md-raised md-warn" ng-click="cancel()"><md-icon>clear</md-icon>Cancel</md-button>' +
        '<md-button class="md-raised md-primary" ng-click="save()" ><md-icon>done</md-icon>Save</md-button>' +
    '</div>'
  };
});